import {takeLatest, put,select} from 'redux-saga/effects';
import {actions as listActions} from '../slices/FeatureListSlice';
import {actions} from '../slices/FeatureSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.featureList.searchCriteria;

function* getFeatureList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_features')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}



function* createFeature({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_features')}`, {
            ...params
        });
        yield put({type: actions.create_feature_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_feature_failed.type, payload: error});
    }
}

function* updateFeature({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_features')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.create_feature_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_feature_failed.type, payload: error});
    }
}

function* deleteFeature({payload:{id}}) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_features')}/${id}`);
        yield put({type: actions.delete_feature_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.delete_feature_failed.type, payload: error});
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getFeatureList);
    yield takeLatest(actions.create_feature.type, createFeature);
    yield takeLatest(actions.update_feature.type, updateFeature);
    yield takeLatest(actions.delete_feature.type, deleteFeature);
}

export default watchRequestDetail;